/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

export default function(basePath, params) {
  const paramStr = params
    ? Object.entries(params)
        .map(kv => kv.map(encodeURIComponent).join("="))
        .join("&")
    : ""

  window.location.href = `${window.location.origin}${basePath}${paramStr}`
}



// WEBPACK FOOTER //
// ./src/service/redirect.js